// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1JFQz","title":"AfterBackImages_title__2oEe8","images":"AfterBackImages_images__1DRuC"};